/**
 * Take the last two parts of the domain e.g. aaa.bbb.ccc.ddd => ccc.ddd
 * @returns {string}
 */
export default function getCurrentDomain() {
  return window.location.hostname.split('.').slice(-2).join('.')
}